module.exports = __webpack_public_path__ + "static/img/govcard_11.ffe95c47.svg";